<app-header-modal [color]="'secondary-2'" title="Alterar Senha">
  <div class="status-header" status>
    <i class="uil uil-times" (click)="close()"></i>
  </div>
</app-header-modal>
<div class="warning" *ngIf="data.showWarning">
  <i class="uil uil-exclamation-triangle"></i>
  <p>Ao alterar a própria senha, você será direcionado para a tela de login.</p>
</div>

<form [formGroup]="form">
  <mat-form-field appearance="outline">
    <mat-label>Nova senha</mat-label>
    <input matInput #passwordInput="matInput" [type]="hidePassword ? 'password' : 'text'" 
      formControlName="password" required>
    <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-pressed]="hidePassword">
      <mat-icon [color]="passwordInput.errorState ? 'warning' : ''">
        {{hidePassword ? 'visibility_off' : 'visibility'}}
      </mat-icon>
    </button>
    <mat-error *ngIf="controls.password?.hasError('required')">Defina uma nova senha</mat-error>
    <mat-error *ngIf="controls.password?.hasError('pattern')">{{ passwordPatternMessage }}</mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Confirme a senha</mat-label>
    <input matInput #passwordInput="matInput" [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirmPassword"
      placeholder="Confirme a senha" required>
    <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" [attr.aria-pressed]="hideConfirmPassword">
      <mat-icon [color]="passwordInput.errorState ? 'warning' : ''">
        {{hideConfirmPassword ? 'visibility_off' : 'visibility'}}
      </mat-icon>
    </button>
    <mat-error *ngIf="controls.confirmPassword?.hasError('passwordMismatch')">As senhas não são iguais</mat-error>
    <mat-error *ngIf="controls.confirmPassword?.hasError('required')">Confirme a senha</mat-error>
  </mat-form-field>

  <div class="buttons">
    <button mat-stroked-button class="gray-2" (click)="close()">cancelar</button>
    <button mat-raised-button class="primary-1" (click)="submit()">
      Salvar
    </button>
  </div>
</form>